import * as router from "../routing/NamaRouter";
import {NamaRouterInstance} from "../routing/NamaRouter";
import {previewPopupView} from "../views/list/ListViewColumns";
import * as mainMenu from "./MainMenu";
import * as navbar from "./Navbar.js";
import * as ApprovalsAndNotifications from "../widgets/ApprovalsAndNotifications";
import {showPasswordMustBeChangedDialog} from "../widgets/ApprovalsAndNotifications";
import {changeFontSize, changeFontType, changeTheme} from "./KednoThemeChooser";
import * as places from "../routing/places";
import {findBusinessIdsForEvent} from "../common/ShortCutsUtil";
import {activateReplicateOptions} from "../routing/NestMode";
import * as KeyboardKey from "../constants/KeyboardKeyCode";
import * as NamaCommon from "../common/NamaCommon";
import {isEmptyOrNull} from "../common/NamaCommon";
import * as NamaURLS from "../constants/NamaURLS";
import {activateServerLog, fillAutoDashboardsAndReports, getGridColors, isServerLogActive, showLastServerLog} from "../login/ClientCache";
import {registerIfNeeded, registerLoginLogoutEvents} from "../login/AutoLogoutTime";
import {currentLoginInfo} from "../login/LoginPresenter";
import {checkSupportDateIfNeeded, scheduleTimedQuery} from "../login/TimedQueryRunner";
import {showFieldInfo_, showHelpMSGs} from "../common/GUIUtilities";
import {FreeLineStyle, LeafItemStyle, MiddleItemStyle, ParentItemStyle, ReturnedItemStyle, SlaveLineStyle} from "../constants/StringConstants";
import {destroyKendoWidgets} from "./list/CriteriaEditorWidget";
import {applicationVersion} from "../common/DefaultApplicationInfo";
import * as notifier from "../common/ErrorsNotification";
import {translateId} from "../common/Translator";
import {initToggleHeaders} from "./edit/EditScreenLayout";

export function clearDOMBody() {
    let domBody = $("#mainPart");
    destroyKendoWidgets(domBody);
    domBody.html("");
    return domBody;
}

export function initMsgsClickOutSideEvents() {
    $(document.body).on("click", function (e) {
        $(".window-save").remove();
        $(".window-errors").remove();
    });
}

export class MainApp {
    constructor() {

    }

    start() {
        router.start();
        this.attachKeyDownEvent();
        initToggleHeaders();
        initMsgsClickOutSideEvents();
        registerLoginLogoutEvents();
        if (applicationVersion() !== window.serverAppVersion)
            notifier.showError(translateId("applicationVersionIsInvalid"));
    }

    afterLogin() {
        let that = this;
        that.render();
        that.initApprovalsAndNotificationsCounter();
        if (that.loginInfo && that.loginInfo.userInfo && that.loginInfo.userInfo.settings.passwordMustBeChanged) {
            showPasswordMustBeChangedDialog();
            return;
        }
        if (instance.loginPresenter && instance.loginPresenter.place) {
            let prevPlace = instance.loginPresenter.place.prevPlace;
            if (prevPlace)
                NamaRouterInstance.goTo(prevPlace);
            else
                NamaRouterInstance.goTo(new places.WelcomePlace());
        }
        registerIfNeeded(currentLoginInfo())
        checkSupportDateIfNeeded("");
        scheduleTimedQuery();
    }

    render() {
        let that = this;
        let domBody = clearDOMBody();
        if ($("#main-wrapper").length) {
            let exampleDiv = $("#example.page-content-wrapper");
            if (exampleDiv.length)
                exampleDiv.html("");
            return;
        }
        let mainWrapper = $("<div id='main-wrapper'/>");
        let navbarElement = navbar.render();
        navbarElement.appendTo(mainWrapper);
        mainWrapper.appendTo(domBody);
        navbar.afterAttach();
        changeTheme(undefined, true);
        changeFontSize(undefined, true);
        changeFontType();
        MainApp.changeGridColors();
        let exampleDiv = $("<div id='example' class='page-content-wrapper'/>");
        exampleDiv.appendTo(mainWrapper);
        NamaCommon.ajaxJSONWithoutWait(NamaURLS.FetchAutoDashboardsAndReports, {}).then((result) =>
            fillAutoDashboardsAndReports(result, () => {
                mainMenu.render();
            })
        );
    }

    static changeGridColors() {
        let map = getGridColors();
        if (isEmptyOrNull(map))
            return;
        let str = "";
        str += MainApp.injectGridColorIfNeeded(map, ParentItemStyle);
        str += MainApp.injectGridColorIfNeeded(map, MiddleItemStyle);
        str += MainApp.injectGridColorIfNeeded(map, LeafItemStyle);
        str += MainApp.injectGridColorIfNeeded(map, FreeLineStyle);
        str += MainApp.injectGridColorIfNeeded(map, SlaveLineStyle);
        str += MainApp.injectGridColorIfNeeded(map, ReturnedItemStyle);
        MainApp.addStyleString(str);
    }

    static dummy() {

    }

    static injectGridColorIfNeeded(map, colorId) {
        if (isEmptyOrNull(map[colorId]))
            return "";
        return `.${colorId} {background-color: ${map[colorId]}`;
    }

    static addStyleString(str) {
        let node = document.createElement('style');
        node.innerHTML = str;
        document.body.appendChild(node);
    }

    /**
     *
     * @returns {namaTypes.CurrentLoginInfo}
     */
    get loginInfo() {
        return instance.loginPresenter.loginInfo;
    }

    initApprovalsAndNotificationsCounter() {
        setTimeout(function () {
            ApprovalsAndNotifications.update();
        }, 1000);
    }

    attachKeyDownEvent() {
        document.onkeydown = (e) => {
            this.fireKeyDownEvent(e);

        };
    }

    fireKeyDownEvent(e) {
        let presenter = NamaRouterInstance.currentPresenter;
        if (e.key === 'Alt' || e.key === 'Control' || e.key === 'Shift')
            return;
        let evtObj = e;
        if (evtObj.keyCode === KeyboardKey.X && evtObj.altKey && evtObj.ctrlKey) {
            activateReplicateOptions();
            return;
        }
        if (evtObj.keyCode === KeyboardKey.I && evtObj.altKey && evtObj.ctrlKey) {
            showFieldInfo_();
            return;
        }
        if (evtObj.keyCode === KeyboardKey.H && evtObj.altKey && evtObj.ctrlKey) {
            if (presenter)
                showHelpMSGs(presenter);
            return;
        }
        if (evtObj.keyCode === KeyboardKey.L && evtObj.altKey && evtObj.ctrlKey) {
            if (isServerLogActive())
                showLastServerLog();
            else
                activateServerLog();
            return;
        }
        if (evtObj.keyCode === KeyboardKey.Esc && previewPopupView != null)
            previewPopupView.off();
        if (!presenter || !presenter.businessFunctions)
            return;
        let _businessFunctions = presenter.businessFunctions();
        if (!_businessFunctions)
            return;
        if (!evtObj.key)
            return;
        let businessIds = findBusinessIdsForEvent(evtObj);
        if (!businessIds)
            return;
        for (let i = 0; i < businessIds.length; i++) {
            let businessId = businessIds [i];
            let callBack = _businessFunctions[businessId];
            if (callBack) {
                e.preventDefault();
                callBack();
                return;
            } else if (presenter.hasGUIAction(businessId)) {
                presenter.callGUIAction(businessId, presenter.metaData);
            }
        }
    }
}

export const instance = new MainApp();
instance.start();
